<template>
    <div class="aba-cliente">
        <container-loader v-if="isLoading && !$store.getters.isLoading" />
        <div class="vertical-flow">
            <div class="columns">
                <div
                    class="column"
                    :class="[
                        permissaoVincular && permissaoCadastrar
                            ? 'is-4'
                            : permissaoVincular || permissaoCadastrar
                            ? 'is-6'
                            : 'is-8',
                    ]"
                >
                    <search-bar
                        :onSearch="debouncedOnSearch"
                        tooltipLabel="msg-campo-busca-usuario-cliente"
                    />
                </div>

                <div
                    class="column"
                    :class="[
                        permissaoVincular && permissaoCadastrar
                            ? 'is-2'
                            : permissaoVincular || permissaoCadastrar
                            ? 'is-3'
                            : 'is-4',
                    ]"
                >
                    <vss-select
                        ref="situacaoSelect"
                        :searchable="false"
                        :options="situacaoSelect"
                        v-model="situacaoSelected"
                        mlLabels
                        title="situacao"
                        clearable
                        @input="onSituacaoChanged"
                        :height="40"
                    />
                </div>

                <div class="column is-3" v-if="permissaoVincular">
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="showModalVincularVendedor"
                    >
                        {{ $t('vincular-usuario') }}
                    </button>
                </div>

                <div class="column is-3" v-if="permissaoCadastrar">
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="
                            $router.push({
                                name: 'usuario-gerenciar-new',
                                query: {
                                    tela: 'cliente-vendedor',
                                    id: $route.params.id,
                                    dadoscadastrais: 2,
                                    politicacomercial: $route.query.politicacomercial
                                        ? $route.query.politicacomercial
                                        : null,
                                    analisecomercial: $route.query.analisecomercial
                                        ? $route.query.analisecomercial
                                        : null,
                                    contexto: isVenda ? 'ven' : 'agro',
                                },
                            })
                        "
                    >
                        {{ $t('adicionar-usuario') }}
                    </button>
                </div>
            </div>

            <div class="registry-wrapper">
                <empty-table-message v-if="isEmpty" />
                <b-table
                    v-else
                    :data="assclienteusuario"
                    class="data-table"
                    @sort="sortTable"
                    backend-sorting
                >
                    <b-table-column
                        v-for="(f, i) in fields"
                        :key="i"
                        :field="f.key"
                        :label="f.key != 'excluir' ? $t(f.key) : ''"
                        :width="f.width"
                        :class="{
                            'excluir-field': f.key == 'excluir',
                        }"
                        :sortable="f.sortable"
                        :custom-sort="f.sortFn"
                        v-slot="props"
                    >
                        <div v-if="f.key == 'nome'">
                            <router-link
                                :to="{
                                    name: 'usuario-gerenciar-edit',
                                    params: { id: +props.row.idusuario },
                                    query: { tela: 'cliente-vendedor', id: $route.params.id },
                                }"
                            >
                                <HideInfo
                                    v-if="!cleanHide"
                                    :value="props.row[f.key]"
                                    :hideInfo="hide.hideInfo"
                                    :infoIsHidden="hide.infoIsHidden"
                                />
                            </router-link>
                            <!-- , -->
                        </div>

                        <div v-else-if="f.key == 'login'">
                            <HideInfo
                                v-if="!cleanHide"
                                :value="props.row[f.key]"
                                :hideInfo="hide.hideInfo"
                                :infoIsHidden="hide.infoIsHidden"
                            />
                        </div>
                        <div v-else-if="f.key == 'excluir'">
                            <b-button
                                v-if="permissao.update && !assClienteUsuarioIntegracao"
                                class="action-button"
                                :type="props.row['replicapda'] == 3 ? 'is-danger' : 'is-success'"
                                :icon-right="props.row['replicapda'] == 3 ? 'delete' : 'check'"
                                @click="promptChangeSituacao(props.row)"
                                v-tippy
                                :title="$t(props.row['replicapda'] == 3 ? 'desativar' : 'reativar')"
                            />
                        </div>
                        <div v-else-if="f.key == 'replicapda'">
                            <b-tag
                                class="table-tag table-tag-full-width"
                                :type="props.row['replicapda'] == 3 ? 'is-success' : 'is-danger'"
                                size="is-medium"
                            >
                                {{ $t(props.row['replicapda'] == 3 ? 'ativo' : 'inativo') }}
                            </b-tag>
                        </div>
                        <div v-else>
                            {{ props.row[f.key] }}
                        </div>
                    </b-table-column>
                </b-table>
                <PaginationViewer
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>

            <!-- MODAL DE ASSOCIACAO -->
            <b-modal :active.sync="showModalAssociacao">
                <div class="bg">
                    <VendedorModal
                        :idCliente="$route.params.id"
                        :permissaoVincular="!assClienteUsuarioIntegracao"
                        @fecharModal="fecharModal"
                    />
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
// SERVICES
import AssClienteVendedorService from '@/services/vendas/cliente/abas/AssClienteVendedorService';
import VendedorModal from '@/components/vendas/cliente/modal/VendedorModal.vue';

// COMPONENTS
import ContainerLoader from '@/components/content/loader/ContainerLoader';
import HideInfo from '@/components/shared/HideInfo';
import { mapState } from 'vuex';

export default {
    components: {
        ContainerLoader,
        VendedorModal,
        HideInfo,
    },
    data() {
        return {
            cleanHide: true,
            assClienteUsuarioIntegracao: this.$store.state.user.tabelasERPWebServer.includes(
                'ASSCLIENTEUSUARIO'
            ),
            usuarioIntegracao: this.$store.state.user.tabelasERPWebServer.includes('USUARIO'),
            assclienteusuario: [],
            fields: [
                { key: 'codigo', width: null, sortable: false, sortFn: null },
                { key: 'nome', width: null, sortable: true, sortFn: null },
                { key: 'login', width: null, sortable: false, sortFn: null },
                { key: 'replicapda', width: 80, sortable: false, sortFn: null },
                { key: 'excluir', width: 20, sortable: false, sortFn: null },
            ],
            service: new AssClienteVendedorService(this.$http, this.$router),
            permissao: false,
            permissaoUsuario: false,
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            situacaoSelected: { id: 4, label: 'todos' },
            situacaoSelect: [
                { id: 4, label: 'todos' },
                { id: 3, label: 'ativos' },
                { id: 2, label: 'inativos' },
            ],
            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            queryFilter: '',
            column: 'nome',
            order: 'asc',
            isSaving: false,
            delete: null,
            showModalAssociacao: false,
            permissaoCadastroUsuario: false,

            //permissoes relativas à exibição dos botões
            permissaoVincular: false,
            permissaoCadastrar: false,

            isVenda: this.$route.meta.contexto == 'vendas',
            isAgro: this.$route.meta.contexto == 'agro',
        };
    },
    computed: {
        ...mapState(['hide']),
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        if (this.isVenda) {
            this.permissao = this.hasPermissionAccess(
                'vendas',
                'clientes',
                'ven-cliente-dados-cadastrais-vendedor'
            );
        } else if (this.isAgro) {
            this.abrev = this.$route.meta.contexto.slice(0, 4);
            this.permissao = this.hasPermissionAccess(
                'agro',
                'clientes',
                'agro-cliente-dados-cadastrais-vendedor'
            );
        }

        this.permissaoCadastroUsuario = this.hasPermissionAccess(
            'admin',
            'gerenciar-usuarios',
            'admin-gerenciar-usuarios'
        );

        this.permissaoVincular = this.permissao.create && !this.assClienteUsuarioIntegracao;
        this.permissaoCadastrar = this.permissaoCadastroUsuario.create && !this.usuarioIntegracao;

        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'clientes' },
            });
        } else {
            this.carregarDados();
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        }
    },
    methods: {
        carregarDados(currentPage = 1) {
            this.cleanHide = true;
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            this.isLoading = true;

            this.findAll(
                this.column,
                this.order,
                currentPage - 1,
                this.pagination.perPage,
                this.situacaoSelected.id,
                this.$route.params.id,
                this.queryFilter
            )
                .then(this.mapItems)
                .then((value) => {
                    this.assclienteusuario = value;
                    this.isEmpty = this.assclienteusuario.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar os usuários!');
                })
                .finally((_) => {
                    this.cleanHide = false;
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        findAll(column, order, page, limit, situacao, id, ...params) {
            if (this.isVenda) {
                return this.service.findAllVendas(
                    column,
                    order,
                    page,
                    limit,
                    situacao,
                    id,
                    ...params
                );
            } else {
                return this.service.findAllAgro(
                    column,
                    order,
                    page,
                    limit,
                    situacao,
                    id,
                    ...params
                );
            }
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            return body.content.map((m) => {
                return {
                    idassclienteusuario: m.id,
                    idusuario: m.usuario.idusuario,
                    codigo: m.usuario.idusuarioerp,
                    nome: m.usuario.nome,
                    login: m.usuario.login,
                    replicapda: m.replicapda,
                    excluir: 'excluir',
                };
            });
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados();
        },
        onSituacaoChanged(val) {
            this.situacaoSelected = val
                ? this.situacaoSelect.filter((v) => v.id == val.id)[0]
                : this.situacaoSelect[0];
            this.carregarDados();
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        promptChangeSituacao(row) {
            this.delete = row;
            let message = this.$t(
                    row.replicapda == 3
                        ? 'msg-confirmacao-desativacao-n'
                        : 'msg-confirmacao-reativacao-n', 
                    { n: row['nome'] }
                );
            this.$root.confirm({
                message: message,
                onConfirm: this.updateSituacaoRegistro,
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.delete = null;
        },
        updateSituacaoRegistro() {
            let tempFailure =
                this.delete.replicapda == 3
                    ? 'msg-erro-ao-desativar-associacao-cliente-usuario'
                    : 'msg-erro-ao-reativar-associacao-cliente-usuario';

            let tempAssClienteUsuario = {
                idassclienteusuario: this.delete.idassclienteusuario,
                replicapda: this.delete.replicapda == 3 ? 2 : 3,
            };

            this.isLoading = true;

            this.updateSituacao(tempAssClienteUsuario)
                .then((r) => {
                    if (r.status == 200) {
                        let tempSuccess =
                            r.content.replicapda == 3
                                ? 'msg-sucesso-ao-reativar-associacao-cliente-usuario'
                                : 'msg-sucesso-ao-desativar-associacao-cliente-usuario';
                        this.$root.showMessage('success', tempSuccess);
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage('error', 'Erro ao atualizar status.');
                    }
                })
                .catch((e) => {
                    console.error('Erro ao atualizar status.', e);
                    this.$root.showMessage('error', tempFailure);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
        updateSituacao(assClienteUsuario) {
            if (this.isVenda) return this.service.updateSituacaoVendas(assClienteUsuario);
            else return this.service.updateSituacaoAgro(assClienteUsuario);
        },
        showModalVincularVendedor() {
            this.showModalAssociacao = !this.showModalAssociacao;
        },
        fecharModal() {
            this.showModalAssociacao = false;
            this.carregarDados();
        },
    },
};
</script>

<style lang="scss" scoped>
.aba-cliente {
    height: 100%;

    .botao-acao {
        margin-top: 24px;
        width: 100%;
        height: 40px;
    }

    @media (max-width: 760px) {
        .search-bar {
            padding-bottom: 0.4rem;
        }

        .botao-acao {
            margin-top: 0;
        }
    }
}
</style>
